const findAttrById = ({ id, product, productType, attributesKey = 'attributes' }) => {
  if (product?.[attributesKey]?.length === 0) {
    if (productType === "NgServiceProduct") {
      return "testKit";
    } if (productType === "NgNonBPProduct") {
      return "petrobras";
    } 
      return undefined;
    
  }
 
  return product?.[attributesKey]?.find(attr => attr.attributeId === id)?.value?.value;
};
 
export default findAttrById;